import { useEffect } from "react";
import {InputRefType, useInputRef} from "../hooks/useInputRef";

export interface ICheckboxListItemLogicProps {
  isChecked: boolean;
  isIndeterminate?: boolean;

}
export interface ICheckboxListItemLogic {
  inputRef: InputRefType;
}

export const useCheckboxListItemLogic = ({isIndeterminate, isChecked}: ICheckboxListItemLogicProps): ICheckboxListItemLogic => {
  const inputRef = useInputRef();
  useEffect(() => {
    inputRef.current.indeterminate = !isChecked && !!isIndeterminate;
  }, [isIndeterminate, isChecked]);

  return {
    inputRef,
  };
}
